var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../index';
var FormatDate = function (date) {
    return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};
var getThumbSrc = function (mapCode, date) {
    //format date time to time to closest minute timestamp for cache breaker
    date = new Date(date);
    date.setSeconds(0);
    date.setMilliseconds(0);
    date = date.getTime() / 1000;
    return {
        backgroundImage: "url(https://www.scribblemaps.com/api/maps/images/".concat(mapCode, "_thumb_450x450.webp?d=").concat(date, ")")
    };
};
var MapDetails = function (_a) {
    var map = _a.map;
    var _b = useContext(AppContext), navigatorShare = _b.navigatorShare, setSelectedEditMap = _b.setSelectedEditMap, setSelectedMap = _b.setSelectedMap, t = _b.t;
    var navigate = useNavigate();
    useEffect(function () {
        if (map.fetchData) {
            fetch("/api/maps/".concat(map.mapCode), { credentials: 'include' }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, response.json()];
                        case 1:
                            data = _a.sent();
                            setSelectedMap(data);
                            return [2 /*return*/];
                    }
                });
            }); }).catch(function (error) {
                navigate('/maps/personal');
            });
        }
    }, [map]);
    return (React.createElement("div", { className: 'mapDetails' },
        React.createElement("div", { className: "downloads" },
            React.createElement("h2", null, t('map_view.download')),
            React.createElement("a", { href: "https://www.scribblemaps.com/api/maps/".concat(map.mapCode, ".gpx?download=true"), target: "_blank", className: 'download' }, "GPX"),
            React.createElement("a", { href: "https://www.scribblemaps.com/api/maps/".concat(map.mapCode, ".json?download=true"), target: "_blank", className: 'download' }, "GeoJSON"),
            React.createElement("a", { href: "https://www.scribblemaps.com/api/maps/".concat(map.mapCode, ".kml?download=true"), target: "_blank", className: 'download' }, "KML")),
        React.createElement("div", { className: "body" },
            React.createElement("div", { className: "title" }, DOMPurify.sanitize(map.title)),
            React.createElement("div", { className: "mapCode" },
                React.createElement("strong", null,
                    t('map_view.id'),
                    ":"),
                " ",
                map.mapCode),
            React.createElement("div", { className: "buttons" },
                React.createElement("button", { className: "view", onClick: function () {
                        var title = map.title.replace(/ /g, '_');
                        title = encodeURIComponent(title);
                        window.open("https://www.scribblemaps.com/maps/view/".concat(title, "/").concat(map.mapCode), '_blank');
                    } }, t('map_view.button_view')),
                navigatorShare && (React.createElement("button", { className: "share", onClick: function () {
                        navigatorShare(map);
                    } }, t('map_view.button_share'))),
                React.createElement("button", { className: "edit", onClick: function () {
                        setSelectedEditMap(map);
                        navigate("/editor");
                        //navigate(`/editor/${map.mapCode}`);
                    } }, t('map_view.button_edit'))),
            React.createElement("div", { className: 'thumbnail' },
                React.createElement("div", { className: 'img', style: getThumbSrc(map.mapCode, FormatDate(map.lastModified)) })),
            React.createElement("div", { className: 'details' },
                React.createElement("div", { className: "description" },
                    React.createElement("h2", null, t('map_view.description_header')),
                    React.createElement("div", null, DOMPurify.sanitize(map.description)),
                    " "),
                React.createElement("div", { className: "dates" },
                    map.teamName && (React.createElement("div", { className: "team" },
                        React.createElement("strong", null, t('map_view.team_header')),
                        React.createElement("div", null, DOMPurify.sanitize(map.teamName)),
                        " ")),
                    map.created && (React.createElement("div", { className: "date" },
                        React.createElement("strong", null, t('map_view.created')),
                        React.createElement("div", null, FormatDate(map.created)))),
                    map.lastModified && (React.createElement("div", { className: "date" },
                        React.createElement("strong", null, t('map_view.modified')),
                        React.createElement("div", null, FormatDate(map.lastModified)),
                        " ")))))));
};
export default MapDetails;
